export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-skype-d03cc715a1d10bfc33da82dce3616608.svg";